define('models/commons/timezone',[
    'underscore',
    'backbone',
    // 'epoxy',
    // 'models/computed-model'
], function(_, Backbone) {

    var MTimezone = Backbone.Epoxy.Model.extend({
        idAttribute: 'key',
        computeds: {
            label: function() {
                return this.get("text");
            },
            value: function() {
                return this.get("key");
            }
        }
    });

    // Return the model for the module
    return MTimezone;
});

